
import React from "react"
import { useNavigate } from 'react-router-dom'

import hotelcss from './css/hotelhotellist.module.css';
import { useEffect } from 'react';
import { useState } from 'react';
import { setErrorMessage, setMessage, clearMessage } from "../tools/errorhandling";
import './css/tabs.css';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import Button from 'react-bootstrap/Button';
import { VscSend } from "react-icons/vsc";
import { AiOutlineSave } from "react-icons/ai";
import DagstaatNode from '../customNodes/DagstaatNode';
import HotelSelection from '../customNodes/HotelSelection';
import moment from 'moment';

import {
    getMyLinkedhotels, gethotel, savedagstaat, updatedagstaat, senddagstaat
} from "../dbconnector/connector";

const Dagstaten = (props) => {
    const t = props.translation
    const [linkedhotels, setLinkedHotels] = useState({});
    const [tabs, setTabs] = useState([]);
    const [tabpanels, setTabPanels] = useState([]);
    const [selectedtab, setSelectedtab] = useState(0);
    const today = new Date();
    const [selectedHotel, setselectedHotel] = useState(null);
    const [selectedDate, setSelectedDate] = useState(addDays(new Date(), 0).toLocaleDateString('en-CA'));

    //dop something after loading page
    useEffect(() => {
        try {
            if ([2, 4].includes(props.rights)) {
                document.getElementById("adminfilterbox").style.display = "block";
            }
            else {
                if ([3].includes(props.rights)) {
                    setselectedHotel(null)
                    document.getElementById("adminfilterbox").style.display = "none";
                }
                else {
                    document.getElementById("adminfilterbox").style.display = "none";
                }
                //  console.log("E")
                // setLinkedHotels({})
                //  console.log("F")
                // const response = getMyLinkedhotels()
                // response.then(res => {

                //     if (res.status === 200) {
                //         res.json().then(linkedhotels => {

                //             setLinkedHotels(linkedhotels.hotels)
                //         })
                //     } else {
                //         setErrorMessage(res.statusText)
                //     }
                // })
            }
        } catch (e) {
            setErrorMessage(t("error_retreivingData"))
        }
    }, []);

    const setselectedtab = (tabid) => {
        //    console.log(tabid)
        setSelectedtab(tabid)
        sessionStorage.setItem('selectedroostertabid', tabid)
    }
    const setDateSchedule = (e) => {

        setSelectedDate(e.target.value)

        if (selectedHotel !== null) {
            getHotelSchedule(selectedHotel, e.target.value);
        }
        else {
            //console.log(e.target.value)
            buildtabs(e.target.value)
        }
         document.getElementById("ID").value = ""
    }
    const setSelectedHotel = (e) => {
        // console.log(e.target)
        setselectedHotel(e.target.value)
        getHotelSchedule(e.target.value, selectedDate);
        document.getElementById("ID").value = ""
    }
    const getHotelSchedule = (hotelID, SelectedDate) => {
        //console.log("getHotelSchedule date: ", moment(SelectedDate).format("YYYY-MM-DD"))
        // console.log("tabs ", tabs[0].props.children)
        setTabs([])
        setTabPanels([])
        gethotel(hotelID).then(res => {
            if (res.status === 200) {
                if (res.hotel.emaildagstaat !== null) {
                    document.getElementById("dagstaatemail").value = res.hotel.emaildagstaat
                } else {
                    document.getElementById("dagstaatemail").value = "email adres voor dagstaten niet gekend voor dit hotel"
                }
                // setTabs(pre => [
                //     <Tab id={res.hotel.hotel_Id} >{res.hotel.Name}</Tab>
                // ]
                // )
                setTabPanels(pre => [
                    //<TabPanel id={"tabPanel" + res.hotel.Hotel_ID}>
                    <DagstaatNode rights={props.rights} hotel={res.hotel} hotelid={res.hotel.Hotel_ID} t={t} datum={moment(SelectedDate).format("YYYY-MM-DD")} />
                    //</TabPanel>
                ]
                )
            } else {
                setErrorMessage(res.statusText)
            }
        })
    }

    function getDate() {
        const today = addDays(new Date(), 1)
        const month = today.getMonth() + 1;
        const year = today.getFullYear();
        const day = today.getDate();
        return `${day}-${month}-${year}`;
    }

    function addDays(date, days) {
        const newDate = new Date(date);
        newDate.setDate(date.getDate() + days);
        return newDate;
    }

    useEffect(() => {
        if (props.rights === 3) {
            buildtabs(selectedDate)
        }
    }, [linkedhotels]);

    const buildtabs = (SelectedDate) => {
        console.log("tabs ", tabs)
        setTabs([])
        setTabPanels([])
        if (linkedhotels.length > 0) {
            linkedhotels.forEach((hotel, index) => {
                setTabs(pre => [...pre,
                <Tab id={"'" + hotel.hotel_Id + "'"} key={"'" + hotel.hotel_Id + "'"} onClick={() => setselectedtab(index)}>{hotel.Name}</Tab>
                ])
                if (!document.getElementById("tabPanel" + hotel.hotel_Id)) {
                    setTabPanels(pre => [...pre,
                    <TabPanel id={"tabPanel" + hotel.hotel_Id} key="0">
                        <DagstaatNode rights={props.rights} hotel={hotel} hotelid={hotel.hotel_Id} t={t} datum={moment(new Date(SelectedDate).toLocaleDateString('en-CA')).format("YYYY-MM-DD")} />
                    </TabPanel>
                    ])
                }
            })
        }
    }

    const SaveDagstaat = async () => {
        const to = document.getElementById("dagstaatemail").value
        const subject = "SHC Dagstaat van " + moment(new Date(selectedDate).toLocaleDateString('en-CA')).format("YYYY-MM-DD")
        const date = new Date(selectedDate).toLocaleDateString('en-CA')
        const dagstaat = document.getElementById("printcanvas").outerHTML
        const ID = document.getElementById("ID").value
        const hotel_Id = selectedHotel


        if (ID.length > 0) {
            console.log(ID, to, subject, dagstaat)
            await updatedagstaat(ID, to, subject, dagstaat, date, hotel_Id).then(res => {
                if (res.status === 200) {
                    res.json().then(body => {
                        setMessage("Dagstaat is succesvol aangepast")
                        document.getElementById("ID").value = body
                    })
                }
                else {
                    setErrorMessage(res.statusText)
                }
            })
        }
        else {

            await savedagstaat(to, subject, dagstaat, date, hotel_Id).then(res => {
                if (res.status === 200) {
                    res.json().then(body => {
                        setMessage("Dagstaat is succesvol bewaard")
                        document.getElementById("ID").value = body
                    })
                }
                else {
                    setErrorMessage(res.statusText)
                }
            })
        }
    }


    const SendDagstaat = async () => {
        const to = document.getElementById("dagstaatemail").value
        const subject = "SHC Dagstaat van " + moment(new Date(selectedDate).toLocaleDateString('en-CA')).format("YYYY-MM-DD")
        const date = new Date(selectedDate).toLocaleDateString('en-CA')
        const dagstaat = document.getElementById("printcanvas").outerHTML
        let id = null;
        if (document.getElementById("ID").value.length > 0)
        {
            id = document.getElementById("ID").value
        }
        console.log(" ddddddddddddd", id)
        const hotel_Id = selectedHotel

        await senddagstaat(id, to, subject, dagstaat, date, hotel_Id).then(res => {
            if (res.status === 200) {
                res.json().then(body => {
                    setMessage("Dagstaat is succesvol verzonden")
                    document.getElementById("ID").value = body
                })
            }
            else {
                setErrorMessage(res.statusText)
            }
        })
    }

    return (
        <>
            <div id="main">
                <header>
                    <div id="errordiv" className='error'></div>
                    <div id="coverAllmessage" className="coverall">
                        <div id="messagediv" className='message'>
                            <div id="messagetext" className="MessageText">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean at justo eu risus molestie egestas a rhoncus tellus.
                                Mauris laoreet, dolor at molestie facilisis, metus lorem ornare felis, nec porta sem nulla id dolor. </div>
                            <center><Button type="button" id="cancelButton" className="OkCancel" onClick={clearMessage}>{t("OK")}</Button></center>
                        </div>
                    </div>
                </header>
                <div className="form" id="adminfilterbox">
                    <label className='formtitleContentBox'>{t('filterinstellingen')}</label>
                    <br></br>
                    <div className="dagstaat_contentbox">
                        <div id="sendtobox" className="dagstaat_header">
                            <div className="emailbutspan">
                                <div className='emailsendbut'>
                                    <VscSend className="emailsendicon" onClick={() => SendDagstaat()} />
                                    <br></br>
                                    {t('Send')}
                                </div>
                                <div className='emailsavebut'>
                                    <AiOutlineSave className="emailsendicon" onClick={() => SaveDagstaat()} />
                                    <br></br>
                                    {t('Save')}

                                </div>
                            </div>
                            {/* <div id="searchboxhotel" className="formElement"> */}
                            <label className='labelcolor'>
                                {t('Hotel')}:
                            </label>
                            <HotelSelection isDisabled={false} data={{ fieldname: "nr_afd", selectedhotel: null, handleitemchange: setSelectedHotel }} valueneeded="hotel_id" checkapproval={false} selectedDate={selectedDate} />

                            <label className='labelcolor'>
                                {t('To')}:
                            </label>
                            <input
                                id='dagstaatemail'
                                type='text'
                                className="email-control"
                                name='To'
                                // value={selectedmessage.id}
                                disabled={false}
                            />
                            <label className='labelcolor'>
                                {t('CC')}:
                            </label>
                            <input
                                id='CC'
                                type='text'
                                className="email-control"
                                name='CC'
                                // value={selectedmessage.id}
                                disabled={false}
                            />
                            <label className='labelcolor'>
                                {t('ID')}:
                            </label>
                            <input
                                id='ID'
                                type='text'
                                className="email-control"
                                name='ID'
                                // value={selectedmessage.id}
                                disabled={true}
                            />


                            {/* </div>
                            <div id="searchboxdate" className="formElement"> */}
                            <label className='labelcolor'>
                                {t('Date')}:
                            </label>
                            <input type="date" id="scheduledate" defaultValue={addDays(new Date(), 0).toLocaleDateString('en-CA')} onChange={setDateSchedule} max={addDays(new Date(), 0).toLocaleDateString('en-CA')}></input>

                            {/* </div> */}
                        </div>
                    </div>
                </div>
                <div id="content" className="form">

                    {/* <label className='formtitle' style={props.rights === 2 ? { display: "none" } : { display: "block" }}>{t('Aanmakendagrooster')} {moment(new Date(selectedDate).toLocaleDateString('en-CA')).format("DD-MM-YYYY")}</label> */}
                    {/* <Tabs className="HotelTabs" id="taboverview" selectedIndex={selectedtab !== undefined ? selectedtab : 0}>
                        <TabList id="tablisthoteloverview">
                            {tabs}
                        </TabList> */}
                    {tabpanels}
                    {/* </Tabs> */}
                </div>
            </div >
        </>
    )
}

export default Dagstaten